import styled from '@emotion/styled';
import { rem } from '@utils';

const Wrapper = styled.div`
  background: var(--action-panel-background-color);
  border-bottom: 1px solid var(--action-panel-border-bottom-color);
  display: flex;
  justify-content: space-between;
  height: var(--action-panel-height);
  padding: 0 ${rem(24)} 0 ${rem(16)};
  grid-area: b;
  z-index: 2;

  .dropdown-menu {
    background: var(--dropdown-menu-icon-background-color);
    color: var(--dropdown-menu-icon-color);

    svg {
      fill: var(--dropdown-menu-icon-color);
    }

    &:hover {
      background: inherit !important;

      svg {
        fill: ${({ theme }) => theme.palette.primary.main};
      }
    }
  }

  @media (max-width: 768px) {
    padding: 0 ${rem(16)};
  }
`;

const ChatTitle = styled.h1<{ isVisible?: boolean }>`
  column-gap: ${rem(4)};
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
  align-items: center;
  justify-content: space-between;
  flex: 1;
  font-size: ${rem(20)};
  font-weight: 600;
  line-height: ${rem(32)};
  margin: 0;
  overflow: hidden;

  .temp-virtual-input {
    position: absolute;
    opacity: 0;
    height: 0;
    font-size: 16px; // Prevent zoom-in on iOS
  }

  .icon {
    background: var(--dropdown-menu-icon-background-color);
    fill: var(--dropdown-menu-icon-color);
  
    &.active {
      background: ${({ theme }) => theme.palette.primary.main};
      fill: ${({ theme }) => theme.palette.common.white};
    }
  }  

  @media (max-width: 1024px) {
    padding-left: ${rem(24)};
  }

  @media (max-width: 636px) {
    font-size: ${rem(16)};
    line-height: ${rem(24)};
  }
`;

const IconButton = styled.span`
  color: var(--action-panel-icon-color);
  cursor: pointer;
  display: inline-flex;
  width: ${rem(32)};
  height: ${rem(32)};
  
  .button-tooltip {
    display: inherit;
    align-items: center;
    justify-content: center;
    width: inherit;
    height: inherit;
  }

  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
  }

  &:focus-visible {
    border-radius: 1px;
    outline: 2px solid ${({ theme }) => theme.palette.primary.dark};
    outline-offset: 4px;
  }
`;

const Editable = styled.span<{ isLoading: boolean }>(
  ({ isLoading, theme }) => `
  background: ${
    isLoading
      ? `linear-gradient(
        to right,
        ${theme.palette.common.white} 0%,
        ${theme.palette.grey['100']} 30%, 
        ${theme.palette.grey['400']} 100%
      )`
      : 'transparent'
  };
  border-radius: ${isLoading ? 0 : 4}px;
  color: ${isLoading ? 'transparent' : 'var(--action-panel-title-color)'};
  height: ${isLoading ? rem(18) : 'auto'};
  overflow: hidden;
  padding: ${rem(2)} ${rem(8)};
  text-overflow: ellipsis;
  text-transform: none;
  white-space: nowrap;
  ${
    isLoading &&
    `
    animation: fade-in-out 500ms ease-in-out infinite alternate;
    max-width: var(--editable-title-max-width); 
    width: 100%;
  `
  }

  @keyframes fade-in-out {
    from {
      opacity: 1;
    }
    to {
      opacity: 0.5;
    }
  }  

  &.has-focus {
    text-overflow: clip;
    overflow: auto;
  }

  // Chrome, Safari, Opera
  &::-webkit-scrollbar {
    display: none;
  }

  &::scrollbar {
    -ms-overflow-style: none; // Edge
    scrollbar-width: none; // Firefox
  }

  &:focus, &:focus-visible {
    outline: 2px solid ${theme.palette.primary.dark};
    outline-offset: -2px;
  }
`
);

const NewChatButton = styled.span`
  display: none;
  position: relative;
  padding-right: ${rem(28)};

  @media (max-width: 1024px) {
    display: flex;
    align-items: center;
  }
`;

export default {
  ChatTitle,
  IconButton,
  Editable,
  NewChatButton,
  Wrapper
};
